import merge from 'lodash.merge';
import type { IResponse, ISearch } from '../types';

type FilterAttributes = { [key: string]: number };

export function resetFilterAttributes(attributes: FilterAttributes) {
  return Object.keys(attributes).reduce((acc, key) => {
    acc[key] = 0;
    return acc;
  }, {} as FilterAttributes);
}

export function mergeFilterAttributesReset(initialData: IResponse<ISearch> | null, data: any) {
  const filter = initialData?.data?.categoryFilterResult?.filter;

  if (!filter) {
    return data;
  }

  return merge(
    {
      data: {
        categoryFilterResult: {
          filter: {
            dfAttributeDfFileType: resetFilterAttributes(filter.dfAttributeDfFileType),
            dfAttributeDfLanguage: resetFilterAttributes(filter.dfAttributeDfLanguage),
          },
        },
      },
    },
    data,
  );
}
